// Case- and punctuation-insensitive matching for group/vehicle-reg search:
// "MH12 AB-1234" and "mh12ab1234" should find the same group.
export function normalizeGroupName(s) {
  return String(s || "")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");
}
